import { render } from "./MenuContentItemTable.vue?vue&type=template&id=213048bc"
import script from "./MenuContentItemTable.vue?vue&type=script&lang=js"
export * from "./MenuContentItemTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__